import { Plan } from '@models/membership/Plan'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_PLANS_URL } from '../../utils/urls'

const fetchPlans = (params: TableParams) =>
  SBAPI.FetchPaginated<Plan[]>(MEMBERSHIP_PLANS_URL, params)

const fetchPlanById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Plan>(`${MEMBERSHIP_PLANS_URL}/${id}`, params)

export { fetchPlanById, fetchPlans }
